"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskProgress = void 0;
const APITasks_1 = require("./resources/APITasks");
const APITask_1 = require("./APITask");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
class TaskProgress {
    constructor() {
        this.bDone = false;
        this.pos = 0;
        this.length = 0;
        this.percent = 0;
        this.timeStart = FSIServerClientUtils_1.FSIServerClientUtils.NOW();
        this.timeElapsed = 0;
        this.etaMS = 0;
        this.eta = "";
        this.logLevel = -1;
        this.temporary = false;
        this.currentTask = new APITask_1.APITask(null, {}, APITasks_1.APITasks.idle);
        this.bytesTotal = 0;
        this.bytesDone = 0;
        this.bytesPerSecond = 0;
        this.bytesDoneBefore = 0;
    }
}
exports.TaskProgress = TaskProgress;
